import axios from "axios";
import Swal from "sweetalert2";

const API_BASE_URL =
  process.env.REACT_APP_API_BASE_URL || "http://localhost:5000";

const axiosInstance = axios.create({
  baseURL: API_BASE_URL,
});

let isRefreshing = false;
let failedQueue = [];

const processQueue = (error, token = null) => {
  failedQueue.forEach((prom) => {
    if (error) {
      prom.reject(error);
    } else {
      prom.resolve(token);
    }
  });

  failedQueue = [];
  isRefreshing = false;
};

axiosInstance.interceptors.request.use(
  (config) => {

    if (
      config.url.includes("/admin/login") ||
      config.url.includes("/admin/refresh-token") ||
      config.url.includes("/admin/logout")
    ) {
      return config;
    }

    const token = sessionStorage.getItem("adminToken");

    if (token) {
      config.headers.Authorization = `Bearer ${token}`;
    }

    return config;
  },
  (error) => Promise.reject(error)
);

axiosInstance.interceptors.response.use(
  (response) => response,

  async (error) => {

    const originalRequest = error.config;

    if (
      error.response &&
      error.response.status === 401 &&
      !originalRequest._retry &&
      !originalRequest.url.includes("/admin/refresh-token")
    ) {

      if (isRefreshing) {

        return new Promise((resolve, reject) => {
          failedQueue.push({ resolve, reject });
        })
          .then((token) => {
            originalRequest.headers.Authorization = `Bearer ${token}`;
            return axiosInstance(originalRequest);
          })
          .catch((err) => Promise.reject(err));
      }

      originalRequest._retry = true;
      isRefreshing = true;

      const refreshToken = sessionStorage.getItem("adminRefreshToken");

      if (!refreshToken) {

        sessionStorage.clear();
        window.location.replace("/admin");

        return Promise.reject(error);
      }

      try {

        const res = await axiosInstance.post(
          "/api/admin/refresh-token",
          { refreshToken }
        );

        const newToken = res.data.token;
        const newRefreshToken = res.data.refreshToken;

        sessionStorage.setItem("adminToken", newToken);
        sessionStorage.setItem("adminRefreshToken", newRefreshToken);

        processQueue(null, newToken);

        originalRequest.headers.Authorization = `Bearer ${newToken}`;

        return axiosInstance(originalRequest);

      } catch (err) {

        processQueue(err, null);

        sessionStorage.clear();

        Swal.fire({
          icon: "warning",
          title: "Session Expired",
          text: "Please login again.",
          confirmButtonText: "Login",
        }).then(() => {
          window.location.replace("/admin");
        });

        return Promise.reject(err);
      }
    }

    return Promise.reject(error);
  }
);

export default axiosInstance;